import { useRegisterEmergencyCall } from '@securecore-new-application/securecore-datacore';
import { LoginDeviceTypes } from '@securecore-new-application/securecore-datacore/lib/types';
import { Layout } from 'antd';
import { Suspense, useCallback } from 'react';
import { Outlet } from 'react-router-dom';

import { DashboardContent, DashboardLayout } from '../components';
import { BreadcrumbPortal, BreadcrumbProvider } from '../components/Breadcrumbs';
import { ErrorsWrapper } from '../components/Errors';
import { Header } from '../components/Header';
import { MobileNavbar } from '../components/MobileNavbar';
import { Navbar } from '../components/Navbar';
import { RenderHero } from '../components/RenderHero';
import { PageLoader } from '../components/ui/PageLoader';
import { UserProvider } from '../contexts/user';
import { useGetScreenStatus } from '../hooks';
import { baseConfig } from '../routes';
import { SCREEN_STATUS } from '../types';

function MainContainer() {
  const currentScreen = useGetScreenStatus();
  const [registerEmergencyCall] = useRegisterEmergencyCall();

  const isExtraSmallScreen = currentScreen === SCREEN_STATUS.extraSmall;

  const onEmergencyCallClick = useCallback(() => {
    registerEmergencyCall({ variables: { data: { deviceType: LoginDeviceTypes.DESKTOP } } }).then();
  }, [registerEmergencyCall]);

  return (
    <UserProvider>
      <BreadcrumbProvider>
        <Layout style={{ position: 'relative' }}>
          {isExtraSmallScreen ? (
            <MobileNavbar emergencyCallClick={onEmergencyCallClick} />
          ) : (
            <Navbar config={baseConfig} emergencyCallClick={onEmergencyCallClick} collapsable footer />
          )}
          <DashboardLayout>
            <Header />
            <DashboardContent isExtraSmallScreen={isExtraSmallScreen}>
              <Suspense fallback={<PageLoader />}>
                <ErrorsWrapper>
                  <>
                    <RenderHero />
                    <Layout className="dashboard-content">
                      <BreadcrumbPortal />
                      <Outlet />
                    </Layout>
                  </>
                </ErrorsWrapper>
              </Suspense>
            </DashboardContent>
          </DashboardLayout>
        </Layout>
      </BreadcrumbProvider>
    </UserProvider>
  );
}

export default MainContainer;
